import { clsx, type ClassValue } from 'clsx'
import { extendTailwindMerge } from 'tailwind-merge-v3'

/**
 * `cn` for the new design ONLY. Do not use it for Ecme components, and do not
 * use Ecme's `@/utils/classNames` here.
 *
 * Two separate Tailwind builds are in the page (see
 * assets/styles/new-design/entry.css), so there are two separate merge configs:
 *
 *  - The old design is Tailwind v3 and uses `tailwind-merge` v2, unchanged, at
 *    utils/classNames.ts and components/ui/utils/classNames.ts.
 *  - The new design is Tailwind v4 with prefix(cl), so it needs tailwind-merge
 *    v3 - v2 cannot parse v4 class names and would mis-merge `shadow` against
 *    `shadow-sm`, which v4 rescaled.
 *
 * Both versions are installed side by side; v3 is aliased as `tailwind-merge-v3`
 * in package.json so the old design's resolution is untouched.
 *
 * `prefix: 'cl'` is required. Without it every class reads as an unknown
 * arbitrary value, conflict groups never match, and `cn('cl:p-2','cl:p-4')`
 * silently keeps both.
 */
const twMerge = extendTailwindMerge({ prefix: 'cl' })

/** flow src/lib/utils.ts:13-15 */
export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
